import { render, staticRenderFns } from "./family-sales-table.vue?vue&type=template&id=72585cda&"
import script from "./family-sales-table.vue?vue&type=script&lang=js&"
export * from "./family-sales-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports